// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xC6m","content":"styles_content__T_ocU"};